import * as React from "react";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import reduceRto from "../../../assets/img/features/reduce-rto.png";

export default function ReduceRto() {
  return (
    <Box
      sx={{
        width: "100%",
        padding:  {xs:"2rem 0", md:"10rem 0"},
        // backgroundColor: 'primary.dark',
        background: "linear-gradient(0deg, rgba(244, 249, 255, 0) 0%, #F4F9FF 100%)",
      }}
    >
      <Box
        sx={{
          height: "inherit",
          width: "inherit",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-evenly",
          alignItems: "center",
        }}
      >
        <Box sx={{ width: { sx: "90vw", md: "40vw" }, padding: "2rem" }}>
          <Typography variant="h3" gutterBottom fontWeight={800}>
            REDUCE RTO UPTO 30%
          </Typography>
          <Typography variant="h5" gutterBottom fontWeight={300} fontSize="1.2rem">
            Automatic detection and disabling of high-risk COD (Cash on
            Delivery) transactions, thereby decreasing operational costs,
            improving customer satisfaction, and increasing overall
            profitability.
          </Typography>
        </Box>
        <Box>
          <img src={reduceRto} alt="loading..." width={350} />
        </Box>
      </Box>
    </Box>
  );
}
